import React from "react";

const LoadingOverlay = () => {
  return (
    <div className="fixed inset-0 bg-gray-300 bg-opacity-75 flex items-center justify-center z-[500]">
      <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-white"></div>
    </div>
  );
};

export default LoadingOverlay;
